import { useTranslation } from '@lyearn/i18n';
import { InfoOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import useIsFaceVerificationNeeded from '@/hooks/useFaceVerification/useIsFaceVerificationNeeded';

export const FaceVerificationMessageInfo = ({ className }: { className?: string }) => {
  const { t } = useTranslation(['ExternalCamera']);
  const isNeeded = useIsFaceVerificationNeeded();

  if (!isNeeded) return null;

  return (
    <Stack
      className={cn('flex w-full flex-1 pt-8 pl-12 pb-8 rounded-8', className ?? 'mt-8')}
      gapX={8}
      style={{ background: 'var(--Black-gray150, #F2F2F2)' }}>
      <InfoOutline className="mt-4" fillColorToken="icon-primary" height={16} width={16} />
      <Typography variant="body-short-03">
        {t('ExternalCamera:FaceVerification.VerificationMessageInfo')}
      </Typography>
    </Stack>
  );
};
